<template>
	<div class="p-grid p-fluid p-justify-center" style="margin-top: -40px;">
		<HomeHeader />
		<AboutHome1 />
		<AboutHome2 />
		<AboutHome3 />
		<HomeFoot />
	</div>
</template>

<script>
import HomeHeader from "@/components/home/HomeHeader";
import HomeFoot from "@/components/home/HomeFoot";
import AboutHome1 from "@/components/home/about/AboutHome1";
import AboutHome2 from "@/components/home/about/AboutHome2";
import AboutHome3 from "@/components/home/about/AboutHome3";

export default {
	components: {
		HomeHeader,
		HomeFoot,
		AboutHome1,
		AboutHome2,
        AboutHome3,
	},
	data() {
		return {
			email: "",
			password: "",
			loginClicked: false,
		};
	},
	beforeCreate: function () {
		document.body.className = "login";
	},
};
</script>
